import {
	USER_GET_FILTERS,
	USER_SET_CURRENT_FILTERS,
	USER_SET_PAGINATION,
	USER_GET_MISSION_FILTERS,
	USER_SET_USERS,
	USER_GET_DYNAMIQUE_FILTER_VALUES,
	USER_SET_SORT,
	USER_SET_KEY_FILTER_SELECTED,
	USER_GET_ALL_CLIENTS,
	UPDATE_USER_CLIENTS,
	GET_SERVICES_LIST,
	GET_ACL_LIST,
	UPDATE_ACL_SERVICE_CLIENT,
	GET_ROLES_LIST,
	UPDATE_USER_ROLE,
	UPDATE_USER_SECTOR,
	UPDATE_USER_KPIS,
	// USER_GET_SECTORS_LIST
} from "../types";
import { getAllSectorsList } from "./allSectorsActions.js";
import { STATS_INIT } from "../../modules/stats/actions/stats";

function action(type, payload = {}) {
	return { type, ...payload };
}

export const setUsers = users => action(USER_SET_USERS, users);
export const getFilters = () => {
	return action(USER_GET_FILTERS);
};

export const setAllUsersClients = () => ({
	type: USER_GET_ALL_CLIENTS,
});

export const getServicesList = () => ({
	type: GET_SERVICES_LIST,
});

export const getAclList = () => ({
	type: GET_ACL_LIST,
});

export const updateUserRole = data => ({
	type: UPDATE_USER_ROLE,
	data,
});

export const updateAclOfServiceClient = data => ({
	type: UPDATE_ACL_SERVICE_CLIENT,
	data,
});

export const getRolesList = () => ({
	type: GET_ROLES_LIST,
});

// export const getAllSectorsList = () => ({
// 	type: USER_GET_SECTORS_LIST
// })

export const init = () => {
	return (dispatch, getState) => {
		const state = getState();

		dispatch(setPagination(1, state.user.pages));
		dispatch(setAllUsersClients());
		// dispatch(getServicesList()); // it's already called when the user is logged in (not linked to the user)
		dispatch(getAclList());
		dispatch(getRolesList());
		dispatch(getAllSectorsList());
		dispatch({ type: STATS_INIT });
	};
};

export const updateUserClients = data => ({
	type: UPDATE_USER_CLIENTS,
	data,
});

export const updateUserKpis = data => ({
	type: UPDATE_USER_KPIS,
	data,
});

export const getMissionFilters = () => {
	return action(USER_GET_MISSION_FILTERS);
};

export const getUsers = data => {
	return (dispatch, getState) => {
		const state = getState();

		dispatch(setPagination(data.page, state.user.pages));
	};
};

export const setSort = (columnKey, sortOrder) => {
	return action(USER_SET_SORT, columnKey, sortOrder);
};

export const setPagination = (page, pages) => ({
	type: USER_SET_PAGINATION,
	page,
	pages,
});

export const setCurrentFilters = currentFilters => ({
	type: USER_SET_CURRENT_FILTERS,
	currentFilters,
});

export function updateFiltersFront(key, filters) {
	return (dispatch, getState) => {
		const state = getState();
		const currentFilters = state.user.currentFilters || {};
		if (filters && (filters.length && filters.length !== 0)) {
			if (key === "clients") currentFilters["clients.label"] = filters;
			else if (key === "role") {
				currentFilters["role_label"] = filters;
			} else currentFilters[key] = filters;
		} else {
			if (key === "clients") delete currentFilters["clients.label"];
			if (key === "role") delete currentFilters["role_label"];
			delete currentFilters[key];
		}

		dispatch(setCurrentFilters(currentFilters));
		dispatch(getUsers({ filters: currentFilters, page: 1 }));
	};
}
export const setKeyFilterSelected = key => ({
	type: USER_SET_KEY_FILTER_SELECTED,
	key,
});
export function getDynFilterValues(key) {
	return action(USER_GET_DYNAMIQUE_FILTER_VALUES, key);
}
export const updateUserSector = (data, page) => ({
	type: UPDATE_USER_SECTOR,
	data,
	page,
});



// WEBPACK FOOTER //
// src/redux/actions/userActions.js